import * as React from "react";
import { makeStyles, useTheme, Theme } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';


import { NumberInput } from "../../atoms/forms/NumberInput";
import { ContactenIcon } from "../../atoms/icons/ContactenIcon";
import { ICommonControlWithMinMax } from "./ICommonInputsControls";


// All the incoming values
interface IProps {

}

// Outgoing functions
interface IDispatch {

}

// Actual Component
export type AllProps = IProps & IDispatch & ICommonControlWithMinMax<number>;
export const ContactsInput = (props: AllProps) => {
    const classes = useStyles(useTheme());
    const { t } = useTranslation('datatypes');
    
    const label = props.label || t('contactenLabel') || "Aantal contacten";

    return (<NumberInput

            {...props}

            label={label}            
            placeholder={t('contactenPlaceholder') || "Aantal contacten..."}
            icon={<ContactenIcon />}

        />
    )
}

// CSS
const useStyles = makeStyles((theme: Theme) => ({ }));